<template>
  <div>
    <div class="content content-fixed content-auth-alt">
      <div class="container ht-100p tx-center">
        <div
          class="ht-100p d-flex flex-column align-items-center justify-content-center"
        >
          <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
            <img src="assets/img/img19.png" class="img-fluid" alt="" />
          </div>
          <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
            404 Мэдээлэл олдсонгүй
          </h1>
          <h5 class="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20">
            Уучлаарай. Таны хадсан мэлээлэл устсан эсвэл системд бүртгэлгүй
            байна.
          </h5>
          <!-- <p class="tx-color-03 mg-b-30">Та доорх хайлтыг ашиглан дахин хайгаарай.</p> -->
          <div class="d-flex mg-b-40">
            <!-- <input type="text" class="form-control wd-200 wd-sm-250" placeholder="Search"> -->
            <router-link
              to="/"
              role="button"
              class="btn btn-primary bd-0 mg-l-5 pd-sm-x-25 text-white"
              >Эхлэл
            </router-link>
          </div>
        </div>
      </div>
      <!-- container -->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
